import { useRef } from 'react';
import { useIntl } from 'react-intl';
import { format } from 'date-fns';
import { Alert } from 'reactstrap';

import Button from 'src/componentes/button';
import Dialog from 'src/componentes/dialog';
import useAuth from 'src/hooks/useAuth';
import { getDataAplicacaoFormularioGlobal } from 'src/paginas/avaliacao-desempenho/PesquisaClima/utils';
import formatDateFns from 'src/utils/formatDateFns';
import AplicacaoStatusBadge from '../AplicacaoStatusBadge';

function PreviaRecorrenciaPesquisaClimaModal({
  aplicacoes = [],
  possuiMaisAplicacoes = false,
  ...rest
}) {
  const intl = useIntl();
  const { user } = useAuth();
  const { currentDisplay, currentLocale } = formatDateFns(user?.idioma, true);
  const dialogRef = useRef();

  const formatarData = (value) => {
    const data = getDataAplicacaoFormularioGlobal(value);

    return data && !Number.isNaN(data.getTime())
      ? format(data, currentDisplay, { locale: currentLocale })
      : '-';
  };

  const renderAplicacao = (aplicacao) => {
    return (
      <li
        key={aplicacao.numero}
        className="d-flex align-items-start border-bottom py-3"
      >
        <span className="text-muted mr-3" style={{ minWidth: 24 }}>
          {aplicacao.numero}.
        </span>
        <span className="flex-grow-1 mr-3">
          {intl.formatMessage(
            { id: 'labelPeriodoAplicacaoPesquisaClima' },
            {
              dataInicio: formatarData(aplicacao.dataInicio),
              dataTermino: formatarData(aplicacao.dataTermino),
            }
          )}
        </span>
        <AplicacaoStatusBadge
          situacao={aplicacao.situacao}
          className="flex-shrink-0"
        />
      </li>
    );
  };

  const handleClose = () => dialogRef.current?.close();

  return (
    <Dialog
      ref={dialogRef}
      width={640}
      maxHeight="80vh"
      ignoreResourceTitle
      textCapitalizeTitle={false}
      titleCapitalizeNone
      title={intl.formatMessage({ id: 'labelPreviaRecorrencia' })}
      actions={[
        <Button color="secondary" key="fechar" onClick={handleClose}>
          {intl.formatMessage({ id: 'label.fechar' })}
        </Button>,
      ]}
      {...rest}
    >
      <div className="p-3">
        <p className="text-muted mb-2">
          {intl.formatMessage({ id: 'msgPreviaRecorrenciaNaoSalva' })}
        </p>
        {aplicacoes.length > 0 ? (
          <ol className="list-unstyled mb-0">
            {[...aplicacoes]
              .sort((a, b) => a.numero - b.numero)
              .map(renderAplicacao)}
          </ol>
        ) : (
          <div className="text-muted text-center py-4">
            {intl.formatMessage({ id: 'msgPreviaRecorrenciaSemAplicacoes' })}
          </div>
        )}
        {possuiMaisAplicacoes && (
          <Alert color="info" className="mt-3 mb-0">
            {intl.formatMessage({ id: 'msgPreviaRecorrenciaMaisAplicacoes' })}
          </Alert>
        )}
      </div>
    </Dialog>
  );
}

export default PreviaRecorrenciaPesquisaClimaModal;
